var $ = require('jquery');
// homepage-default-popup start

// $(document).ready(function () {
//     $('#Disclaimer-popup-lu').modal('show');
// });

    // homepage-default-popup end
//    modal popup js start 
$(document).ready(function () {
    $('.video-popup').on("click", function () {
        var url = $(this).attr('data-url');
        $('#iframe1').attr("src", url);
    });
    $('#myModalffour').find('.iframe-popup-close').on("click", function () {
        $("iframe").attr('src', '');
    });


    var scrollLink = $('.scroll');

    // Smooth scrolling
    scrollLink.click(function (e) {
        e.preventDefault();
        $('body,html').animate({
            scrollTop: $(this.hash).offset().top
        }, 1000);
    }); 

})
//  modal popup js end


